import { Box, Button, FormControl, FormLabel, Tooltip } from '@mui/material'
import { TextField } from 'components/textField'
import { inject, observer } from 'mobx-react'
import { Company } from 'models'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AuthStore } from 'stores'

export interface ICompanyForm {
  authStore?:             AuthStore
  company?:               Company
  dontSave?:              boolean
  required?:              boolean
  onSave?:                () => void
  onCancel?:              () => void
  hasConfirmationButtons?: boolean
}

export const CompanyForm = inject(
  'authStore',
  'routingStore'
)(
  observer((props: ICompanyForm) => {
    const { t } = useTranslation()
    const {
      hasConfirmationButtons,
      company,
      dontSave,
      required,
      onSave,
      onCancel,
    } = props
    const _company: Company = company 
    const disableSubmit = !_company.title || !_company.sparta_id 

    return (
      <Box>
          <FormControl
            sx={{ display: 'flex', flexDirection: 'column' }}
            margin='normal'
          >
            <FormLabel required={required}>{t('company_name')}</FormLabel>
            <TextField
              hiddenLabel
              fullWidth
              variant  = 'outlined'
              value    = {_company.title}
              onChange = {(e) =>
                _company.set('title', e.target.value, !dontSave)
              }
            />
          </FormControl>

          <FormControl
            sx={{ display: 'flex', flexDirection: 'column' }}
            margin='normal'
          >
            <FormLabel required={false}>{t('sparta_id')}</FormLabel>
            <TextField
              fullWidth
              hiddenLabel
              type     = 'number'
              value    = {_company.sparta_id}
              onChange = {(e) =>
                _company.set('sparta_id', e.target.value, !dontSave)
              }
              variant='outlined'
            />
          </FormControl>


        {hasConfirmationButtons &&
          <FormControl
            sx     = {{ display: 'flex', flexDirection: 'row', marginTop: 3}}
            margin = 'normal'
          >
          <Tooltip title={disableSubmit ? t('tooltip_fill_required_fields') : ''}>
            <Box>
            <Button
              variant  = 'contained'
              disabled = {disableSubmit}
              onClick  = {onSave}
            >
              {t('save')}
            </Button>
            </Box>
            </Tooltip>
            <Button variant='text' onClick={onCancel}>
              {t('cancel')}
            </Button>
          </FormControl>
        }
      </Box>
    )
  })
)
